import type React from 'react'
import { cn } from '@/lib/utils'
import { ArgusLogo } from '../decorative/argus-logo'
import { Card } from './card'
import { Text } from './text'

export function PageCard({
  title,
  description,
  containerClassName,
  children,
}: {
  title: string
  description: React.ReactNode
  containerClassName?: string
  children?: React.ReactNode
}) {
  return (
    <div className="mx-8 flex justify-center">
      <div className="py-8 w-full max-w-156 flex items-center justify-center min-h-screen">
        <Card className="w-full min-h-112 md:min-h-100 flex flex-col">
          <ArgusLogo width={42} height={26} />
          <h1 className="mt-8 mb-2 font-nb-architekt text-xl leading-[1.1] tracking-[0.04em] text-white uppercase">
            {title}
          </h1>

          <Text block font="beausite" size={16} color="white">
            {description}
          </Text>

          <div className={cn('mt-8', containerClassName)}>{children}</div>
        </Card>
      </div>
    </div>
  )
}
